import React from "react";
import { useParams, Link } from "react-router-dom";
import "../Flight/FlightDetails.css";
import { MdOutlineFlightTakeoff } from "react-icons/md";
import { MdOutlineFlightLand } from "react-icons/md";
import FlightDeal from "./Flightdeal";
import WhyChoose from "../WhyChoose/WhyChoose";

const flights = [
    {
      id: "usa",
      city: "USA",
      economy: "£1840",
      premiumEconomy: "£3040",
      image: "/san.jpg",
      description:
      "The United States, a vast and diverse country, offers everything from bustling cities to breathtaking natural landscapes. Explore iconic destinations like New York City, known for Times Square and the Statue of Liberty, or Los Angeles, home to Hollywood and sunny beaches. The USA is also rich in history, with landmarks such as the White House in Washington, D.C., and the Grand Canyon in Arizona. Whether you seek adventure, culture, or relaxation, the USA has something for everyone.",
    description2:
      "Each region in the USA has its own unique charm. Experience the vibrant nightlife of Miami, the tech hubs of Silicon Valley, or the scenic beauty of the Rocky Mountains. The country boasts a world-class food scene, from deep-dish pizza in Chicago to barbecue in Texas. Outdoor enthusiasts can explore national parks like Yellowstone and Yosemite, while city lovers can immerse themselves in the cultural hotspots of San Francisco, Boston, and Las Vegas. No matter your interests, the USA promises unforgettable experiences.",
      destinations: [
        {
          name: "Golden Gate Bridge",
          image: "/golden.jpg"
        },
        {
          name: "Alcatraz Island",
          image: "/alkatraz.jpg"
        },
        {
          name: "Fisherman's Wharf",
          image: "/whraf.jpg"
        }
      ],
    "relatedFlights": [
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Orlando",
    "airport": "MCO",
    "departureDate": "15 May 2025",
    "returnDate": "22 May 2025",
    "price": "£499",
    "airline": "British Airways",
    "logoPath": "/ba.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "New York",
    "airport": "JFK",
    "departureDate": "18 May 2025",
    "returnDate": "25 May 2025",
    "price": "£399",
    "airline": "United",
    "logoPath": "/united.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Las Vegas",
    "airport": "LAS",
    "departureDate": "20 May 2025",
    "returnDate": "27 May 2025",
    "price": "£499",
    "airline": "Virgin Atlantic",
    "logoPath": "/virgina.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Toronto",
    "airport": "YYZ",
    "departureDate": "20 May 2025",
    "returnDate": "27 May 2025",
    "price": "£389",
    "airline": "WestJet",
    "logoPath": "/westjet.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Vancouver",
    "airport": "YVR",
    "departureDate": "20 May 2025",
    "returnDate": "27 May 2025",
    "price": "£529",
    "airline": "Air Canada",
    "logoPath": "/aircanada.png"
  }
]



    },
    {
      "id": "canada",
      "city": "Canada",
      "economy": "£1540",
      "premiumEconomy": "£2840",
      "image": "/canada.jpg",
      "description": 
        "Canada, the second-largest country in the world, is known for its stunning natural landscapes, vibrant cities, and welcoming culture. From the iconic CN Tower in Toronto to the scenic beauty of Banff National Park, Canada offers a diverse range of experiences. Visitors can explore the historic streets of Quebec City, enjoy the multicultural charm of Vancouver, or witness the power of Niagara Falls. The country's vast wilderness provides endless opportunities for adventure, including skiing in Whistler, hiking in the Rockies, and wildlife spotting in the Arctic.",
      "description2": 
        "Canada is a country of contrasts, with bustling metropolises and serene natural wonders. Experience the French heritage of Montreal, the modern skyline of Calgary, and the cultural richness of Ottawa. Food lovers can indulge in poutine, butter tarts, and fresh seafood from the Atlantic coast. The country's friendly people, rich history, and breathtaking landscapes make it a must-visit destination. Whether you're seeking urban excitement or outdoor adventure, Canada has something for everyone.",
      "destinations": [
        {
          "name": "Niagara Falls",
          "image": "/fall.jpg"
        },
        {
          "name": "CN Tower",
          "image": "/cntower.jpg"
        },
        {
          "name": "Banff National Park",
          "image": "/banff.jpg"
        }
      ],
      "relatedFlights": [
        {
          "from": "London",
          "fromAirport": "LHR",
          "destination": "Calgary",
          "airport": "YYC",
          "departureDate": "15 May 2025",
          "returnDate": "22 May 2025",
          "price": "£479",
          "airline": "Delta Air Lines",
          "logoPath": "/delta.png"
        },
        {
          "from": "London",
          "fromAirport": "LHR",
          "destination": "Montreal",
          "airport": "YUL",
          "departureDate": "18 May 2025",
          "returnDate": "25 May 2025",
          "price": "£529",
          "airline": "American Airlines",
          "logoPath": "/americana.png"
        },
        {
          "from": "London",
          "fromAirport": "LHR",
          "destination": "Halifax",
          "airport": "YHZ",
          "departureDate": "20 May 2025",
          "returnDate": "27 May 2025",
          "price": "£549",
          "airline": "Air transat",
          "logoPath": "/transat.png"
        },
        {
          "from": "London",
          "fromAirport": "LHR",
          "destination": "Toronto",
          "airport": "YYZ",
          "departureDate": "20 May 2025",
          "returnDate": "27 May 2025",
          "price": "£389",
          "airline": "west jet",
          "logoPath": "/westjet.png"
        },
        {
          "from": "London",
          "fromAirport": "LHR",
          "destination": "Vancouver",
          "airport": "YVR",
          "departureDate": "20 May 2025",
          "returnDate": "27 May 2025",
          "price": "£529",
          "airline": "air canada",
          "logoPath": "/aircanada.png"
        }
      ]
    }
,    
    {
      id: "caribbean",
      city: "Caribbean",
      economy: "£1680",
      premiumEconomy: "£2800",
      image: "/cari.jpg",
      description: "The Caribbean is a paradise of sun, sea, and sand, offering pristine beaches, crystal-clear waters, and vibrant cultures. From the Bahamas to Jamaica, each island boasts its own unique charm. Explore the lush rainforests of Dominica, relax on the white sandy beaches of Barbados, or dive into the vibrant marine life of the Cayman Islands. The Caribbean is also known for its rich history, with colonial-era towns and lively festivals celebrating its diverse heritage.",
      description2: "Beyond its breathtaking beaches, the Caribbean is home to world-class resorts, delicious cuisine, and thrilling water sports. Snorkel in the coral reefs of Belize, dance to reggae in Jamaica, or take a scenic drive through the Pitons of St. Lucia. Whether you're seeking adventure, relaxation, or cultural exploration, the Caribbean promises an unforgettable escape with its warm hospitality and stunning landscapes.",
      destinations: [
        {
          name: "Seven Mile Beach, Jamaica",
          image: "/jama.jpg" 
        },
        {
          name: "Pitons, St. Lucia",
          image: "/pitons.jpg" 
        },
        {
          name: "Old San Juan, Puerto Rico",
          image: "/old.jpg"
        }
      ],
     relatedFlights: [
  {
    from: "London",
    fromAirport: "LHR", // London Heathrow
    destination: "Antigua",
    airport: "ANU", // V.C. Bird International Airport (Antigua)
    departureDate: "8 June 2025",
    returnDate: "15 June 2025",
    price: "£599",
    airline: "Virgin Atlantic",
    logoPath: "/virgina.png"
  },
  {
    from: "London",
    fromAirport: "LHR",
    destination: "Montego Bay",
    airport: "MBJ", // Sangster International Airport (Jamaica)
    departureDate: "12 June 2025",
    returnDate: "19 June 2025",
    price: "£549",
    airline: "Virgin Atlantic",
    logoPath: "/virgina.png"
  },
  {
    from: "London",
    fromAirport: "LHR",
    destination: "Kingston",
    airport: "KIN", // Norman Manley International Airport (Jamaica)
    departureDate: "15 June 2025",
    returnDate: "22 June 2025",
    price: "£549",
    airline: "British Airways",
    logoPath: "/ba.png"
  },
  {
    from: "London",
    fromAirport: "LHR",
    destination: "Bridgetown",
    airport: "BGI", // Grantley Adams International Airport (Barbados)
    departureDate: "15 June 2025",
    returnDate: "22 June 2025",
    price: "£579",
    airline: "American airways",
    logoPath: "/americana.png"
  },
  {
    from: "London",
    fromAirport: "LHR",
    destination: "Nassau",
    airport: "NAS", // Lynden Pindling International Airport (Bahamas)
    departureDate: "15 June 2025",
    returnDate: "22 June 2025",
    price: "£589",
    airline: "Delta",
    logoPath: "/delta.png"
  }
]

    },
    {
      id: "a&n",
      city: "Australia and New Zealand",
      economy: "£1760",
      premiumEconomy: "£2880",
      image: "/aus.jpg",
      description: "Australia and New Zealand offer breathtaking landscapes, vibrant cities, and unique wildlife. From the iconic Sydney Opera House to New Zealand’s fjords and Maori culture, this region is a dream for adventurers and relaxation-seekers alike. Explore Australia’s Outback, dive the Great Barrier Reef, or ski in Queenstown. With world-class wines, stunning coastlines, and cosmopolitan cities like Melbourne and Auckland, there’s something for everyone.",
      description2: "Beyond the cities, discover New Zealand’s Middle-earth filming locations, Australia’s ancient rainforests, and pristine beaches like the Whitsundays. Whether you’re hiking Franz Josef Glacier, tasting wine in Marlborough, or spotting kangaroos in the wild, Australia and New Zealand promise unforgettable experiences. Their friendly locals, outdoor adventures, and laid-back vibe make them perfect for long-haul escapes.",
      destinations: [
        {
          name: "Great Barrier Reef, Australia",
          image: "/reef.jpg" 
        },
        {
          name: "Milford Sound, New Zealand",
          image: "/milford.jpg"
        },
        {
          name: "Uluru (Ayers Rock), Australia",
          image: "/uluru.jpg"
        }
      ],
     "relatedFlights": [
  {
    "from": "London",
    "fromAirport": "LHR", // London Heathrow
    "destination": "Sydney",
    "airport": "SYD", // Sydney Kingsford Smith Airport
    "departureDate": "7 May 2025",
    "returnDate": "14 May 2025",
    "price": "£699",
    "airline": "Air China",
    "logoPath": "/airchina.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Perth",
    "airport": "PER", // Perth Airport
    "departureDate": "10 May 2025",
    "returnDate": "17 May 2025",
    "price": "£799",
    "airline": "Luftshana",
    "logoPath": "/luftshana.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Melbourne",
    "airport": "MEL", // Melbourne Airport
    "departureDate": "12 May 2025",
    "returnDate": "19 May 2025",
    "price": "£879",
    "airline": "Royal Brunei",
    "logoPath": "/royalb.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Auckland",
    "airport": "AKL", // Auckland International Airport
    "departureDate": "12 May 2025",
    "returnDate": "19 May 2025",
    "price": "£699",
    "airline": "China Eastern",
    "logoPath": "/chinaeastern.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Christchurch",
    "airport": "CHC", // Christchurch International Airport
    "departureDate": "12 May 2025",
    "returnDate": "19 May 2025",
    "price": "£1199",
    "airline": "Air New Zealand",
    "logoPath": "/airnewzealand.png"
  }
]

      
    },
    {
      "id": "ca",
      "city": "Central America",
      "economy": "£2320",
      "premiumEconomy": "£3360",
      "image": "/central.jpg", 
      "description": "Central America is a vibrant region bridging North and South America, known for its lush rainforests, volcanic landscapes, and pristine beaches. From the Mayan ruins of Guatemala to the cloud forests of Costa Rica and the Panama Canal, this region offers rich biodiversity and cultural heritage. Explore colonial cities like Antigua, surf in El Salvador, or dive in Belize’s Great Blue Hole. Central America’s affordability and adventure opportunities make it a favorite for eco-tourists and backpackers.",
      "description2": "Beyond its natural wonders, Central America boasts vibrant cultures, from the Garifuna communities of Honduras to the indigenous markets of Chichicastenango. Zip-line through Costa Rican jungles, hike active volcanoes in Nicaragua, or relax on Panama’s San Blas Islands. With warm hospitality, flavorful cuisine (think pupusas and gallo pinto), and UNESCO World Heritage sites, this compact region packs a punch for travelers seeking authenticity and adventure.",
      "destinations": [
        {
          "name": "Tikal, Guatemala",
          "image": "/tital.jpg" 
        },
        {
          "name": "Arenal Volcano, Costa Rica",
          "image": "/arenal.jpg"
        },
        {
          "name": "Roatán, Honduras",
          "image": "/rotan.jpg" 
        }
      ],
      "relatedFlights": [
  {
    "from": "London",
    "fromAirport": "LHR", // London Heathrow
    "destination": "Mexico City",
    "airport": "MEX", // Mexico City International Airport
    "departureDate": "25 June 2025",
    "returnDate": "2 July 2025",
    "price": "£799",
    "airline": "Aeroméxico",
    "logoPath": "/aeromexico.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Cancun",
    "airport": "CUN", // Cancun International Airport
    "departureDate": "28 June 2025",
    "returnDate": "5 July 2025",
    "price": "£749",
    "airline": "Air France",
    "logoPath": "/airfrance.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Bogota",
    "airport": "BOG", // El Dorado International Airport (Bogotá)
    "departureDate": "1 July 2025",
    "returnDate": "8 July 2025",
    "price": "£845",
    "airline": "klm",
    "logoPath": "/klm.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Punta Cana",
    "airport": "PUJ", // Punta Cana International Airport
    "departureDate": "1 July 2025",
    "returnDate": "8 July 2025",
    "price": "£799",
    "airline": "Avianca",
    "logoPath": "/avi.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Quito",
    "airport": "UIO", // Mariscal Sucre International Airport (Quito)
    "departureDate": "1 July 2025",
    "returnDate": "8 July 2025",
    "price": "£699",
    "airline": "United",
    "logoPath": "/united.png"
  }
]

    },
    {
      id: "india",
      city: "India",
      economy: "£2235",
      premiumEconomy: "£3256",
      image: "/india.jpg",
      description:
        "India, a land of diverse cultures and landscapes, offers something for every traveler. From the majestic Himalayas in the north to the serene backwaters of Kerala in the south, India is a country of contrasts. Explore the iconic Taj Mahal in Agra, a symbol of love and one of the Seven Wonders of the World. The bustling cities of Delhi, Mumbai, and Bangalore showcase India's rapid modernization, while its rural villages offer a glimpse into traditional life.",
      description2:
        "India's rich history is reflected in its countless temples, forts, and palaces, such as the Amber Fort in Jaipur and the temples of Khajuraho. The country's cuisine is equally diverse, with each region offering its own unique flavors and dishes. Don't miss the vibrant festivals, such as Diwali and Holi, which celebrate India's cultural heritage. Whether you're exploring its ancient landmarks or indulging in its culinary delights, India promises an unforgettable journey.",
      destinations: [
        {
          name: "Taj Mahal",
          image: "/tajmahal.jpg"
        },
        {
          name: "Jaipur",
          image: "/jaipur.jpg"
        },
        {
          name: "Kerala Backwaters",
          image: "/kerala.jpg"
        }
      ],
     "relatedFlights": [
  {
    "from": "London",
    "fromAirport": "LHR", // London Heathrow
    "destination": "Delhi",
    "airport": "DEL", // Indira Gandhi International Airport, Delhi
    "departureDate": "3 September 2025",
    "returnDate": "10 September 2025",
    "price": "£499",
    "airline": "Air India",
    "logoPath": "/airindia.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Mumbai",
    "airport": "BOM", // Chhatrapati Shivaji Maharaj International Airport, Mumbai
    "departureDate": "7 September 2025",
    "returnDate": "14 September 2025",
    "price": "£495",
    "airline": "Gulf Air",
    "logoPath": "/gulfair.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Goa",
    "airport": "GOI", // Goa International Airport
    "departureDate": "12 September 2025",
    "returnDate": "19 September 2025",
    "price": "£545",
    "airline": "Qatar",
    "logoPath": "/qatar.jpg"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Chennai",
    "airport": "MAA", // Chennai International Airport
    "departureDate": "12 September 2025",
    "returnDate": "19 September 2025",
    "price": "£569",
    "airline": "Virgin Atlantic",
    "logoPath": "/virgina.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Bangalore",
    "airport": "BLR", // Kempegowda International Airport, Bangalore
    "departureDate": "12 September 2025",
    "returnDate": "19 September 2025",
    "price": "£529",
    "airline": "British Airways",
    "logoPath": "/ba.png"
  }
]

    },
    {
      "id": "fareast",
      "city": "Far East",
      "economy": "£1920",
      "premiumEconomy": "£2960",
      "image": "/fareast.jpg", 
      "description": "The Far East is a mesmerizing blend of ancient traditions and cutting-edge modernity, spanning from Japan's neon-lit cities to Indonesia's tropical paradises. Explore Tokyo's futuristic skyline, Kyoto's serene temples, or the Great Wall of China. Dive into the street food scenes of Bangkok and Taipei, or unwind on Bali's pristine beaches. The region's rich history, diverse cultures, and stunning landscapes make it a bucket-list destination for every traveler.",
      "description2": "From the bustling markets of Hong Kong to the tranquil rice terraces of Vietnam's Sapa, the Far East offers endless contrasts. Trek through Malaysia's Borneo rainforest, marvel at Angkor Wat's sunrise in Cambodia, or experience Seoul's K-pop culture. Whether you're seeking spiritual retreats in Bhutan, tech wonders in Singapore, or island-hopping in the Philippines, the Far East delivers unforgettable adventures with warm hospitality and unparalleled diversity.",
      "destinations": [
        {
          "name": "Great Wall of China",
          "image": "/greatwall.jpg" 
        },
        {
          "name": "Mount Fuji, Japan",
          "image": "/fuji.jpg"
        },
        {
          "name": "Angkor Wat, Cambodia",
          "image": "/angkor.jpg"
        }
      ],
     "relatedFlights": [
  {
    "from": "London",
    "fromAirport": "LHR", // London Heathrow
    "destination": "Manila",
    "airport": "MNL", // Ninoy Aquino International Airport, Manila
    "departureDate": "15 August 2025",
    "returnDate": "22 August 2025",
    "price": "£579",
    "airline": "China Southern", // Correct airline for London to Manila
    "logoPath": "/chinasouthern.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Seoul",
    "airport": "ICN", // Incheon International Airport, Seoul
    "departureDate": "18 August 2025",
    "returnDate": "25 August 2025",
    "price": "£689",
    "airline": "Cathay Pacific", // Correct airline for London to Seoul
    "logoPath": "/cathay.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Toyoko",
    "airport": "NRT", // Narita International Airport, Tokyo
    "departureDate": "20 August 2025",
    "returnDate": "27 August 2025",
    "price": "£787",
    "airline": "All Nippon", // Correct airline for London to Tokyo
    "logoPath": "/ana.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Beijing",
    "airport": "PEK", // Beijing Capital International Airport
    "departureDate": "20 August 2025",
    "returnDate": "27 August 2025",
    "price": "£584",
    "airline": "Air China", // Correct airline for London to Beijing
    "logoPath": "/airchina.png"
  },
  {
    "from": "London",
    "fromAirport": "LHR",
    "destination": "Singapore",
    "airport": "SIN", // Singapore Changi Airport
    "departureDate": "20 August 2025",
    "returnDate": "27 August 2025",
    "price": "£728",
    "airline": "Singapore Airlines", // Correct airline for London to Singapore
    "logoPath": "/singapore.png"
  }
]

    },
    {
      "id": "middleeast",
      "city": "Middle East",
      "economy": "£1600",
      "premiumEconomy": "£2720",
      "image": "/middle.jpg", // Generic image of Middle Eastern landscape
      "description": "The Middle East is a captivating blend of ancient history and futuristic innovation, from the towering skyscrapers of Dubai to the archaeological wonders of Petra. Explore the bustling souks of Marrakech, the sacred sites of Jerusalem, or the pristine beaches of Oman. The region’s rich cultural heritage, warm hospitality, and dramatic landscapes—from deserts to coastlines—make it a must-visit for history buffs, adventurers, and luxury seekers alike.",
      "description2": "Beyond modern marvels like the Burj Khalifa, discover the timeless beauty of Egypt’s Pyramids of Giza, the ruins of Palmyra in Syria, or the spice-scented alleyways of Istanbul. Cruise the Nile, dive in the Red Sea, or trek through Jordan’s Wadi Rum. With world-class cuisine (think mezze, kebabs, and Arabic coffee) and vibrant traditions, the Middle East offers a journey through millennia of civilization.",
      "destinations": [
        {
          "name": "Petra, Jordan",
          "image": "/petra.jpg" // The iconic "Rose City"
        },
        {
          "name": "Pyramids of Giza, Egypt",
          "image": "/pyramids.jpg"
        },
        {
          "name": "Al-Ula, Saudi Arabia",
          "image": "/alula.jpg" // Ancient Nabatean ruins
        }
      ],
     "relatedFlights": [
  {
    "from": "London",
    "fromAirport": "DXB",  // Dubai International Airport
    "destination": "Abu Dhabi",
    "airport": "AUH",  // Abu Dhabi International Airport
    "departureDate": "5 April 2025",
    "returnDate": "12 April 2025",
    "price": "£389",
    "airline": "Etihad",
    "logoPath": "/etihad.png"
  },
  {
    "from": "London",
    "fromAirport": "DOH",  // Hamad International Airport, Doha
    "destination": "Doha",
    "airport": "DOH",  // Corrected to match Doha
    "departureDate": "8 April 2025",
    "returnDate": "15 April 2025",
    "price": "£438",
    "airline": "Qatar Airways",
    "logoPath": "/qatar.jpg"
  },
  {
    "from": "London",
    "fromAirport": "RUH",  // King Khalid International Airport, Riyadh
    "destination": "Dubai",
    "airport": "DXB",  // Dubai International Airport
    "departureDate": "10 April 2025",
    "returnDate": "17 April 2025",
    "price": "£376",
    "airline": "Emirates",
    "logoPath": "/emirates.jpg"
  },
  {
    "from": "London",
    "fromAirport": "RUH",
    "destination": "Muscat",
    "airport": "MCT",  // Muscat International Airport
    "departureDate": "10 April 2025",
    "returnDate": "17 April 2025",
    "price": "£449",
    "airline": "Oman Air",
    "logoPath": "/oman.png"
  },
  {
    "from": "London",
    "fromAirport": "RUH",
    "destination": "Riyadh",
    "airport": "RUH",  // King Khalid International Airport, Riyadh
    "departureDate": "10 April 2025",
    "returnDate": "17 April 2025",
    "price": "£489",
    "airline": "Saudia",
    "logoPath": "/saudia.png"
  }
]

    }
  ];

const FlightDetails = () => {
  const { id } = useParams();
  const flight = flights.find((f) => f.id === id);

  if (!flight) {
    return <h2 className="flight-error">Flight not found</h2>;
  }
  const handleCall = () => {
    window.location.href = `tel:"02038852600"`;
};
  return (
    <div className="flight-details-container">
      {/* Poster Image with City Name Overlay */}
      <div className="poster-container">
        <img src={flight.image} alt={flight.city} className="poster-image" />
        <div className="city-overlay">{flight.city}</div>
      </div>
      <FlightDeal/>

      {/* Main Content */}
      <div className="content-container">
        {/* Left Div (70%) */}
        <div className="left-div">
          <h1>Flights to {flight.city}</h1>
          <div className="button-div">
            <button className="call-now-button" onClick={handleCall}>Call Now</button>
            <p className="phone-deals-text">
              For phone-only deals: Save up to 70% on {flight.city} flights.
            </p>
          </div>
          <p className="city-description">{flight.description}</p>
          <p className="city-description">{flight.description2}</p>
        </div>

        {/* Right Div (30%) */}
        <div className="right-div">
          <h1>Talk to a Travel Expert Now</h1>
          <p className="phone-number">+02038852600</p>
          <Link to="/contactus">
          <button className="call-back-button" >Request a Call Back</button>
          </Link>
        </div>
      </div>

      {/* Related Flights Section */}
      <div className="related-flights-section">
        <h2 className="related-flights-title">Your results for great value flights to {flight.city}</h2>

        <div className="flights-container">
          {flight.relatedFlights.map((relatedFlight, index) => (
            <div key={index} className="flight-card">
              <div className="airline-logo">
                <img src={relatedFlight.logoPath} alt={relatedFlight.airline} />
              </div>
              <div className="flight-details">
                <div className="flight-route">
                  <p><span className="flight-route-span">From:</span> {relatedFlight.from} ({relatedFlight.fromAirport})</p>
                  <p><span className="flight-route-span">Destination:</span> {relatedFlight.destination} ({relatedFlight.airport})</p>
                </div>
                <div className="flight-dates">
                  <div className="departure">
                    <span className="flight-icon"><MdOutlineFlightTakeoff className="fflo"/></span>{/*-{relatedFlight.departureDate}-*/} 
                  </div>
                  <div className="return">
                    <span className="flight-icon"><MdOutlineFlightLand className="fflo"/></span>{/*- {relatedFlight.returnDate}-*/} 
                  </div>
                </div>
              </div>
              <div className="flight-price">
                from <span className="price-value">{relatedFlight.price}</span>
                <button onClick={handleCall} className="button-14">Call Now</button>
              </div>
              
            </div>
          ))}
        </div>
      </div>

      {/* City Destinations Section */}
      <div className="city-destinations-section">
        <h2 className="destinations-title">{flight.city} Destinations</h2>
        
        <div className="destinations-container">
          {flight.destinations.map((destination, index) => (
            <div key={index} className="destination-card">
              <div className="destination-image-container">
              <a href={`tel:02038852600`} className="call-now-buttonn">
            Call Now
          </a>
                <img src={destination.image} alt={destination.name} className="destination-image" />
              </div>
              <div className="destination-name">{destination.name}</div>
            </div>
          ))}
        </div>
      </div>
      <WhyChoose/>
    </div>
  );
};

export default FlightDetails;